import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { useAnalytics } from "../../contexts/analytics/hooks";
import { useHospitalData } from "../../contexts/HospitalDataProvider";
import { buildTeamAgencyConfigurationUrl } from "../team/AgencyWages/deepLink";
import { BreakdownRouteLink } from "./BreakdownRouteLink";
import { FooterLinkLabel } from "./FooterLinkLabel";
import { RuleCard } from "./RuleCard/RuleCard";
import { WageSettingsLink } from "./WageSettingsLink";

/**
 * Where this shift's rates are set: the department's rate rules on Wage Settings — or, for an agency shift,
 * whose base is the agency's bill rate, Team → Agency Configuration.
 */
export const FooterRatesLink: FC<{ isAgency: boolean }> = ({ isAgency }) => {
	const { t } = useTranslation();
	const { track } = useAnalytics();
	const { chosenDepartment } = useHospitalData();
	const departmentId = chosenDepartment.department_id;
	if (!isAgency) {
		return (
			<WageSettingsLink
				label={<FooterLinkLabel label={t("wageBreakdown.footer.rateRules")} />}
				ariaLabel={t("wageBreakdown.footer.rateRules")}
				dataTestId="wage-breakdown-footer-rate-rules-link"
			/>
		);
	}
	return (
		<BreakdownRouteLink
			to={buildTeamAgencyConfigurationUrl(departmentId)}
			destination="agency_configuration"
			label={<FooterLinkLabel label={t("wageBreakdown.footer.agencyRates")} />}
			onClick={() => track("wage_breakdown_open_agency_configuration", { department_id: departmentId })}
			dataTestId="wage-breakdown-footer-agency-link"
			emphasis="strong"
			hoverCard={<RuleCard subjects={[{ kind: "agency" }]} dataTestId="wage-breakdown-agency-card" />}
		/>
	);
};
